/* eslint-disable max-len */
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { getUser } from '../../selectors';
import { getShops } from '../../../shops/reducers';
import { saveUser } from '../../actions';
import withNotifications from '../../../../common/withNotifications';
import { getInitialValues } from '../../helpers/form';
import { USER_TYPES } from '../../../../auth/constants';

const mapStateToProps = (state, props) => ({
  user: getUser(state, props.params.id),
  shops: getShops(state),
  initialValues: getInitialValues({
    kind: props.location.query.kind,
  }),
});

const mapDispatchToProps = {
  saveUser,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withNotifications,
  withState('tmpPassword', 'setTmpPassword', ''),
  withHandlers({
    saveNewUser: (props) => (data) =>
      props.saveUser(data).then((user) => {
        let message = 'User created successfully. Check top of screen for temporary password.';

        if (user.kind !== USER_TYPES.regularAdmin && user.kind !== USER_TYPES.agent) {
          message = user.isAccountOwner
            ? 'This user was added to this account, and will be considered the Account Owner. Check top of screen for temporary password.'
            : 'This user was added to this account, but is not considered the Account Owner. Check top of screen for temporary password.';
        }
        props.addNotification({
          title: 'Success',
          level: 'success',
          message,
        });
        props.setTmpPassword(user.password);
        return user;
      }),
  })
);
